import {Component, Injectable, OnDestroy, OnInit} from '@angular/core';
import {ToastyService, ToastOptions} from 'ng2-toasty';
import {Observable} from 'rxjs';
import {UserAware, UserAwareBase} from '../../domain/model/user/user-aware.class';
import {AuthService} from '../../components/security/authorization/auth.service';
import {applyMixins} from '../../common/mixins/mixins.util';
import {UserImpersonationService} from '../../domain/model/user/user-impersonation.service';
import {RolesAware} from '../../domain/authorization/roles-aware.class';
import {OcrService} from '../../components/ocr/ocr.service';

@Component({
    selector: 'my-top-navigation',
    template: require('./top-nav.component.html'),
    styles: [require('./top-nav.component.scss')]
})
@Injectable()
export class TopNavComponent extends RolesAware(UserAware(UserAwareBase)) implements OnInit, OnDestroy {

    STATIC_URL_SERVICES: string = process.env.STATIC_URL_SERVICES || '';
    STATIC_URL_WHY_MEDPRO: string = process.env.STATIC_URL_WHY_MEDPRO || '';

    stompSub: any;

    constructor(authService: AuthService,
                private readonly _impersonationService: UserImpersonationService,
                protected ocrService: OcrService,
                protected toastyService: ToastyService) {
        super(authService);
    }

    impersonatingUser$: Observable<boolean> = this._impersonationService.impersonatedUserChange$;

    stopImpersonatingUser() {
        this._impersonationService.stopImpersonatingUser(['admin']);
    }

    ngOnInit(): void {
        this.stompSub = this.ocrService.taskCompleted$.subscribe((msg_body: string) => {
            if (msg_body === 'COMPLETED') {
                this.showResumeToast();
            }
        });
    }

    showResumeToast() {
        const toastOptions: ToastOptions = {
            title: 'Resume Processed',
            msg: '<a href="/resume">Your resume has been processed, see what we found in the resumes page.</a>',
            showClose: true,
            timeout: 60000,
            theme: 'bootstrap'
        };
        this.toastyService.success(toastOptions);
    }

    ngOnDestroy(): void {
        this.stompSub.unsubscribe();
    }
}

applyMixins(TopNavComponent, [UserAware]);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/navigation/top/top-nav.component.ts